import React from 'react';
import { CircularProgress, Stack } from '@mui/material';

function AktivuLoader(props) {
  return (
    <Stack alignItems="center" sx={{ marginTop: 50 }}>
      <CircularProgress />
    </Stack>
  );
}

export default AktivuLoader;
